import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/ALogin'),
    },
    {
      name: 'tvViewer',
      path: '/tvViewer/:mode/:weekId/:id/:dayString',
      props: true,
      component: () =>  import('./views/TVViewer'),
    },
    {
      name: 'externalRestaurantInfoAdv',
      path: '/extRestInfo/:addressId/:week/:carteId',
      props: true,
      component: () => import('./views/ExternalRestaurantInfo'),
    },
    {
      name: 'externalRestaurantInfo',
      path: '/extRestInfo',
      component: () => import('./views/ExternalRestaurantInfo'),
    },
    {
      name: 'extRestCarteEditor',
      path: '/extRestCarteEditor/:addressId',
      props: true,
      component: () => import('./views/ExternalRestaurantCarteEditor'),
    },
    {
      name: 'netDelivery',
      path: '/netDelivery',
      component: () => import('./views/NetDeliveryInfo'),
    },
    {
      name: 'extAdmin',
      path: '/extAdmin',
      component: () => import('./views/ExtAdmin'),
    },
    {
      name: 'netDeliveryPayer',
      path: '/netDeliveryPayer/:weekId/:deliveryRouteId',
      component: () => import('./views/NetDeliveryPayer'),
      props: true,
    },
    {
      name: 'netDeliveryReOrder',
      path: '/netDeliveryReOrder/:weekId/:deliveryRouteId',
      component: () => import('./views/DeliveryReOrder'),
      props: true,
    },
    {
      name: 'netDeliveryNewOrder',
      path: '/netDeliveryNewOrder/:weekId/:addressId',
      component: () => import('./views/DeliveryNewOrder'),
      props: true,
    },
    {
      name: 'netDeliveryApp',
      path: '/netDeliveryApp/:dayId/:deliveryRouteId',
      component: () => import('./views/DeliveryApp'),
      props: true,
    },
    {
      path: '/a',
      component: () => import('./views/ext/ExtBase'),
      children: [
        {
          path: 'tudnivalok/',
          name: 'tudnivalok',
          component: () => import('./views/ext/pages/InfoPage'),
        },
        {
          path: 'cimlap/',
          name: 'cimlap',
          component: () => import('./views/ext/pages/Home'),
        },
        {
          path: 'etlap/',
          name: 'etlap',
          component: () => import('./views/ext/pages/CartePage'),
        },
        {
          path: 'belepes/',
          name: 'belepes',
          component: () => import('./views/ext/pages/LoginPage'),
        },
      ]
    }
  ]
})
